<template>
  <upPopup
    :show="show"
    @close="close"
    title="倾听师等级"
    :showCloseBtn="true"
    :autoHeight="false"
    :buttons="buttons"
    :label="'我知道了'"
    class="qingsu-level-rule-model-box"
  >
    <div class="qingsu-level-rule-model">
      <div>
        <dl class="list" v-for="(item, index) in rules" :key="index">
          <dt class="title" v-if="item.title">
            {{ item.title }}
          </dt>
          <dd
            :class="{ desc: true, 'desc-pb': index === 5 }"
            v-html="item.desc"
          ></dd>
        </dl>
      </div>
    </div>
  </upPopup>
</template>

<script>
import upPopup from '../common/upPopup.vue'

export default {
  components: {
    upPopup
  },
  props: {
    rules: {
      type: Array,
      default() {
        return [
          {
            desc:
              '壹心理以严格的标准审核并面试倾听师，对倾听师的胜任力进行持续的监督管理，为来访者提供高质量心理服务。'
          },
          {
            title: '知心倾听师',
            desc:
              '掌握了一定心理倾听技术，在不断的学习和经验成长中，能胜任情绪困扰等问题处理。'
          },
          {
            title: '陪伴倾听师',
            desc:
              '心理倾听技术得到一定提升，倾听累计超过60小时，在不断的经验积累中，能够处理情绪疏导、个人成长等需求。'
          },
          {
            title: '解惑倾听师',
            desc:
              '心理倾听技术和经验都得到提升，倾听累计超过325小时，在每月较为稳定的参加督导的情况下，能够胜任大多数情绪问题及心理困扰。'
          },
          {
            title: '排忧倾听师',
            desc:
              '具备丰富的经验和较为成熟的倾听技术，倾听累计超过1250小时，每月能较为稳定的参加督导，能够胜任情绪问题及心理困扰。'
          },
          {
            title: '资深倾听师',
            desc:
              '具备非常丰富的经验和成熟的倾听技术，倾听累计超过4000小时，有较为稳定的督导，擅长处理多种类型的情绪问题及心理困扰。'
          }
        ]
      }
    },
    show: {
      type: Boolean,
      default: false
    },
    buttons: {
      type: Array,
      default() {
        return [{ label: '我知道了' }]
      }
    }
  },
  methods: {
    close() {
      this.$emit('update:show', false)
    }
  }
}
</script>

<style lang="scss">
.qingsu-level-rule-model-box {
  .common-model-up-btn {
    height: 86px;
    background: linear-gradient(180deg, #fecec6 0%, #fc7052 100%);
    border-radius: 48px;
    .common-model-up-btn-label {
      font-size: 32px;
      font-weight: 600;
    }
  }
  .common-model-up-close-btn {
    display: none;
  }
}
.qingsu-level-rule-model {
  padding: 20px 30px 43px;
  max-height: 800px;
  .list {
    padding-bottom: 20px;
    .desc {
      font-size: 26px;
      color: #6c798c;
      line-height: 38px;
      margin-bottom: 50px;
    }
    .desc-pb {
      margin-bottom: 0;
    }
  }
  .title {
    display: flex;
    align-items: center;
    font-size: 32px;
    color: #21252d;
    line-height: 32px;
    position: relative;
    margin-bottom: 20px;
    font-weight: 500;
  }

  .close-btn {
    font-size: 26px;
    color: #ffffff;
    line-height: 28px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 80px;
    background: #ffa202;
  }
}
</style>
